import gql from 'graphql-tag';
export const MarkInlineCommentsReadMutation = gql`
	mutation MarkInlineCommentsReadMutation($commentIds: [ID!]!) {
		markCommentsAsRead(input: { commentIds: $commentIds }) {
			success
			errors
		}
	}
`;
